import React from "react";
import { Container, Button } from "reactstrap";

const Home = () => {
  return (
    <Container fluid className="main-content landing-section">
      <div className="main-paragraph container">
        <h1>Hi, there.</h1>
        <p>
          My name is Thanapoom.
          <br />
          A junior web designer/developer.
          <br />
          I can help you with basic web technologies.
          <br />
          Nice to meet ya!
        </p>
        <a href="/contact">
          <Button color="danger">Get in touch</Button>
        </a>
      </div>
    </Container>
  );
};

export default Home;
